import warn from '../utils/console/warn';

/**
 * Function to check if the user has access to the permission
 * @param {*} permission 
 */
export default function hasAccess(permission) {
    if(!window.capAuth) {
      warn("Cap auth not initialized. Please initialize cap auth to use this method");
      return;
    }
    const { permissions } = window.capAuth;
    return permissions.includes(permission);
  }